import React, { Component } from 'react';
import { Container, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { COLORS } from '../../utils/Application_Constants';
import UserContext from '../../contexts/userContext';
import { WithContexts } from '../../contexts/withContexts';
import ManageCVV2 from '../../components/ContentComponents/Qualifications/ManageCVV2';
import ErrorDialog from '../../components/GlobalComponents/Dialog/ErrorDialog';

const styles = (theme) => ({
    root: {
        padding: '80px 0',
        minHeight: '800px',
        [theme.breakpoints.down('md')]: {
            paddingTop: '60px',
            marginTop: '25px',
        },
        backgroundColor: COLORS.BLACK_HAZE,
    },
    dropdownRoot: {
        padding: '10px 0',
        display: 'flex',
        flexWrap: 'wrap',
    },
    helpPanelRoot: {
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    dropdownContainerRoot: {
        border: `1px solid ${COLORS.WHITE_LILAC}`,
        width: '100%',
        padding: '20px 20px',
        textAlign: 'left',
        borderRadius: '3px',
        position: 'relative',
    },
    buttonRoot: {
        lineHeight: 'inherit',
        margin: '0 30px 20px',
        padding: 0,
        width: '100%',
        borderRadius: '0px',
        textTransform: 'none',
        boxShadow: 'none',
    },
    helpPanelContainerRoot: {
        padding: '20px',
        display: 'flex',
        flexWrap: 'wrap',
    },
    helpPanelHeader: {
        marginBottom: '10px',
    },
    helpPanelLinks: {
        textAlign: 'left',
        marginBottom: '10px',
    },
    helpPanelButton: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        paddingBottom: '10px',
        borderRadius: '0px',
        textTransform: 'none',
        boxShadow: 'none',
    },
    header: {
        color: COLORS.ST_TROPAZ,
        fontWeight: '700',
        fontSize: '20px',
        margin: 0,
    },
    linkHeader: {
        color: COLORS.RAVEN,
        fontWeight: '700',
        fontSize: '20px',
        margin: 0,
    },
    chevronRoot: {
        position: 'absolute',
        width: '25px',
        right: '20px',
        color: COLORS.TRUE_BLUE,
    },
    progressWrapper: {
        height: '80vh',
    },
    progressRoot: {
        marginTop: '25vh',
    },
    link: {
        color: COLORS.TRUE_BLUE,
        marginBottom: '10px',
        textDecoration: `underline dotted ${COLORS.LIGHT_BLUE}`,
        fontWeight: '400',
        fontSize: '16px',
        cursor: 'pointer',
        display: 'block',
    },
    disabeldInput: {
        opacity: 0.6,
    },
    saveButton: {
        marginLeft: '32px',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            margin: '20px 32px',
        },
    },
    saveMessage: {
        margin: '10px',
        [theme.breakpoints.down('md')]: {
            margin: '0px 30px',
        },
    },
    errorMessage: {
        color: 'red',
    },
});
/**
 * Landing page for Account
 */
class ManageCVPage extends Component {
    constructor(props) {
        super(props);
        const { PageContext: { setPageName } = {} } = this.props;
        setPageName('Manage CV');
        this.state = {
            handleSubmit: null,
            childTab: null,
            flags: {
                missingData: false,
                dataSaved: false,
                isDirty: false,
                showSaveChanges: false,
                isPendingSave: false,
                targetTab: 0,
                errorMessage: '',
                apiError: null,
            },
        };
    }

    setManageCVError = (e) => {
        const state = { ...this.state };
        if (
            Object.prototype.hasOwnProperty.call(e, 'title') &&
            Object.prototype.hasOwnProperty.call(e, 'message')
        ) {
            state.flags.apiError = e;
        } else {
            state.flags.errorMessage = 'Error loading page';
        }
        state.flags.isLoading = false;
        this.setState({ ...state });
    };

    closeError = () => {
        const state = { ...this.state };
        state.flags.apiError = null;
        this.setState({ ...state });
    };

    updateFlags = (flags) => {
        this.setState({ flags });
    };

    setSaveHandler = (child, handler) => {
        const state = { ...this.state };
        state.childTab = child;
        state.handleSubmit = handler;
        // Reset save flags
        state.flags.missingData = false;
        state.flags.dataSaved = false;
        state.flags.isDirty = false;
        state.flags.showSaveChanges = false;
        state.flags.isPendingSave = false;
        this.setState({ ...state });
    };

    render() {
        const { classes } = this.props;
        const { UserContext: { externalId } = {} } = this.props;
        const state = { ...this.state };
        const { flags } = this.state;
        return (
            <div className={classes.root}>
                <ErrorDialog
                    open={!!flags.apiError}
                    onClose={this.closeError}
                    title={!flags.apiError ? null : flags.apiError.title}
                    description={!flags.apiError ? null : flags.apiError.message}
                    errorId={!flags.apiError ? null : flags.apiError.errorId}
                />
                <Container maxWidth="xl">
                    <Grid item xs={12}>
                        <Grid container justifyContent="space-evenly">
                            <Grid item xs={12} md={8}>
                                {/* <Paper classes={{ root: classes.dropdownRoot }}> */}
                                <ManageCVV2
                                    externalId={externalId}
                                    flags={state.flags}
                                    updateFlags={this.updateFlags}
                                    setSaveHandler={this.setSaveHandler}
                                    setManageCVError={this.setManageCVError}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        );
    }
}
ManageCVPage.contextType = UserContext;

ManageCVPage.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
    }).isRequired,
};
export default WithContexts(withTranslation()(withStyles(styles)(ManageCVPage)));
